export default "__VITE_ASSET__CDndcRog__"